<template>
  <div class="my-order-wrap"  v-loading="loading">
    <div class="table-header-tab-wrap">
      <div class="tab" :class="{'active': curTabIndex === 0}" @click="selectType('B', 0)">我的买单</div>
      <div class="tab" :class="{'active': curTabIndex === 1}" @click="selectType('S', 1)">我的卖单</div>
      <div class="tab" :class="{'active': curTabIndex === 2}" @click="selectType('B', 2)">买方交收单</div>
      <div class="tab" :class="{'active': curTabIndex === 3}" @click="selectType('S', 3)">卖方交收单</div>
      <div class="right-wrap">
        <el-input placeholder="请输入编号或品牌" v-model="query.searchStr" @keyup.enter.native="retrieve(1)" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="retrieve(1)"></el-button>
        </el-input>
      </div>
    </div>
    <div class="table-wrapper" v-if="queryType === 0">
      <el-table :data="tableData" stripe key="direction">
        <el-table-column label="订单编号" prop="orderCode" width="150" />
        <el-table-column label="品牌" prop="brandName" />
        <el-table-column label="升贴水单价" prop="liftingWater" width="90" />
        <el-table-column label="等级" prop="grade" width="50" />
        <el-table-column label="榨季" prop="season" width="60" />
        <el-table-column label="交货方式" prop="deliveryType" width="100">
          <template slot-scope="scope">
            {{scope.row.deliveryType | keyFilter("releaseQuotation", "deliveryType").name}}
          </template>
        </el-table-column>
        <el-table-column label="交货地" prop="addressStr" />
        <el-table-column label="仓库名" prop="wareHouseAddress" />
        <el-table-column label="备注" prop="remark" />
        <el-table-column :label="query.directionType === 'B' ? '卖方' : '买方'" :prop="query.directionType === 'B' ? 'sellerName' : 'buyerName'" />
        <el-table-column label="成交时间" prop="orderDate" width="100" />
        <el-table-column label="成交数量(吨)" prop="orderQuantity" width="100"/>
        <el-table-column label="未交收数量" prop="canDeliveredQuantity" width="100" />
        <el-table-column label="总金额(元)" prop="amount" width="90" />
        <el-table-column label="状态" width="130" :prop="query.directionType === 'B' ? 'buyerOrderStatus' : 'sellerOrderStatus'">
          <template slot-scope="scope">
            <div v-if="query.directionType === 'B'">
              {{scope.row.buyerOrderStatus | keyFilter("quotation", "buyerStatus").name}}
              <!--代交挂牌商品履约金的显示倒计时-->
              <div class="status-box" v-if="scope.row.buyerOrderStatus === '10'">
                {{ scope.row.surplusTimes }}
              </div>
            </div>
            <div v-else>
              {{scope.row.sellerOrderStatus | keyFilter("quotation", "sellerStatus").name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <div class="operate-button" @click="toDetail(scope.row)">详情</div>
            <!--买方交收申请-->
            <div class="operate-button red-button"
                 @click="toDelivery(scope.row, 'B')"
                 v-if="query.directionType === 'B' && scope.row.canDeliveredQuantity !== 0 && (scope.row.buyerOrderStatus === '20' || scope.row.buyerOrderStatus === '30')">
              申请交收
            </div>
            <!--卖方交收申请-->
            <div class="operate-button red-button" @click="toDelivery(scope.row, 'S')"
                 v-if="query.directionType === 'S' && scope.row.canDeliveredQuantity !== 0 && scope.row.sellerOrderStatus === '50'">
              申请交收
            </div>
            <div class="operate-button red-button"
                 v-if="query.directionType === 'S' && scope.row.canDeliveredQuantity !== 0 && scope.row.sellerOrderStatus === '40'">
              <apply-drop-down :rowData="scope.row" />
            </div>
            <div class="operate-button" @click="cancel(scope.row, 'del')" v-if="query.directionType === 'B' && scope.row.buyerOrderStatus === '10'">取消</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <pagination :data="pageData" @retrieve="retrieve" />
      </div>
    </div>
    <div class="table-wrapper" v-else>
      <el-table :data="tableData" stripe v-loading="loading" key="delivery">
        <el-table-column label="交收单号" prop="deliveryCode" width="160" />
        <el-table-column label="订单编号" prop="orderCode" width="160" />
        <el-table-column label="升贴水单价" prop="liftingWater" />
        <el-table-column label="品牌" prop="brandName" />
        <el-table-column label="等级" prop="grade" />
        <el-table-column label="移仓方式" prop="moveWarehouseType">
          <template slot-scope="scope">
            {{ scope.row.moveWarehouseType | keyFilter("myOrder", "moveWarehouseType").name }}
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="deliveryQuantity" />
        <el-table-column label="状态" prop="deliveryStatus">
          <template slot-scope="scope">
            <div v-if="scope.row.deliveryStatus !== '50'">
              {{ scope.row.deliveryStatus | keyFilter("myOrder", "deliveryDirection").name }}
            </div>
            <div v-else>
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" v-html="changeHtml(scope.row.pcAuditRemark)"></div>
                <div class="auditRemark">已驳回
                  <div class="tip_button"><i class="el-icon-info"></i>查看原因</div>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <div class="operate-button"
                 v-if="scope.row.deliveryStatus === '10'"
                 @click="cancel(scope.row, 'withdraw')">撤回</div>
            <div class="operate-button"
                 v-if="scope.row.deliveryStatus === '50' || scope.row.deliveryStatus === '60'"
                 @click="reapply(scope.row)">重新申请</div>
            <div class="operate-button" @click="toDeliveryDetail(scope.row)">详情</div>
            <div class="operate-button" @click="toDownload(scope.row)">下载</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <pagination :data="pageData" @retrieve="retrieve" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ApplyDropDown from './components/ApplyDropdown'
const { mapState } = createNamespacedHelpers('framework')

export default {
  name: 'MyOrder',
  components: {
    ApplyDropDown
  },
  data () {
    return {
      curTabIndex: 0, // 当前焦点tab的索引
      tableData: [],
      pageData: {}, // 表格分页数据
      pageSize: 10, // 表格一页数据数量
      currentNo: 1, // 当前页
      query: { // 查询参数
        directionType: 'B',
        deliveryDirection: 'B',
        searchStr: ''
      },
      queryType: 0, // 查询类型，0是买卖单，1是交收单
      loading: false // 加载
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
    }),
  },
  watch: {
    // 本页面做了热缓存，需要根据不同来源页进行不同的刷新操作
    '$route' (to, from) {
      if (this.$route.path !== '/framework/myTrading/myOrder') {
        return
      }
      if (from.path.includes('myOrder')) { // 来源页是在“我的订单”内部，那么对原有表格进行数据刷新
        this.retrieve()
      } else { // 来源页是其它菜单，那么初始化到第一个菜单进行请求
        this.queryType = 0
        this.curTabIndex = 0
        this.query.directionType = 'B'
        this.retrieve(1)
      }
    },
    userInfo: { // 登录信息改变的时候刷新数据
      handler () {
        this.retrieve(1)
      },
      deep: true
    }
  },
  methods: {
    // 获取表格数据
    retrieve (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.loading = true
      this.currentNo = currentNo || this.currentNo || 1
      const url = this.queryType === 0 ? this.$API.myOrder.retrieve : this.$API.myOrder.myDeliveryApply
      const param = this.$utils.objectAssign({}, this.query, {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
      })
      if (this.queryType === 0) { // 根据类型，去除查询参数中的无用项
        delete param.deliveryDirection
      } else {
        delete param.directionType
      }
      this.$http.post(url, param).then(res => {
        this.tableData = res.data.rows
        this.pageData = res.data
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.pageData = {}
        this.loading = false
      })
    },
    // 将字符串中的换行符替换成HTML的换行标签
    changeHtml (str) {
      return str.replace(/\n/g, '<br/>')
    },
    // 选择买卖方向
    selectType (type, index) {
      this.queryType = index < 2 ? 0 : 1 // 查询类型,0是买卖单，1是交收单
      this.curTabIndex = index // 更新当前焦点索引
      if (this.queryType === 0) {
        this.query.directionType = type // 对应方向
      } else {
        this.query.deliveryDirection = type // 交收单对应方向
      }
      this.retrieve(1) // 请求表格数据
    },
    // 查看详情
    toDetail (row) {
      this.$router.push({ path: `/framework/myTrading/myOrder/orderDetail/${row.id}/${this.query.directionType}` })
    },
    // 查看交收单详情
    toDeliveryDetail (row) {
      if (this.curTabIndex === 2) { // 买方交收单详情
        // 神策数据收集
        this.$sensors.track('SettlementBuyerOrderProcessing', { operation: '买方交收单处理', details: '详情' })
        this.$router.push({ path: `/framework/myTrading/myOrder/buyerDeliveryDetail/${row.id}` })
      } else { // 卖方交收单详情
        // 神策数据收集
        this.$sensors.track('SettlementSellerOrderProcessing', { operation: '卖方交收单处理', details: '详情' })
        this.$router.push({ path: `/framework/myTrading/myOrder/sellerDeliveryDetail/${row.id}` })
      }
    },
    // 申请交收
    toDelivery (row, type) {
      if (type === 'B') { // 买方交收单
        // 神策数据收集
        this.$sensors.track('BuyerOrderProcessing', { operation: '买方订单处理', apply_settlement: '申请交收' })
        this.$router.push({ path: `/framework/myTrading/myOrder/buyerDelivery/${row.id}/B` })
      } else { // 卖方交收单
        this.$router.push({ path: `/framework/myTrading/myOrder/sellerDelivery/${row.id}/S` })
      }
    },
    // 跳转交收单下载页
    toDownload (row) {
      const url = this.curTabIndex === 2 ? `/buyerDeliveryPreview/${row.id}` : `/sellerDeliveryPreview/${row.id}`
      // 神策数据收集
      if (this.curTabIndex === 2) {
        // 神策数据收集
        this.$sensors.track('SettlementBuyerOrderProcessing', { operation: '买方交收单处理', download: '下载' })
      } else {
        // 神策数据收集
        this.$sensors.track('SettlementSellerOrderProcessing', { operation: '卖方交收单处理', download: '下载' })
      }
      const routeData = this.$router.resolve({ path: url })
      window.open(routeData.href, '_blank')
    },
    // 取消订单(type === 'del')和撤回交收单(type === 'withdraw')
    cancel (row, type) {
      const url = type === 'del' ? this.$API.myOrder.buyerCancelOrder : this.$API.myOrder.recallDelivery
      const tip = type === 'del' ? '您确定要取消该订单吗？' : '您确定要撤回该交收单吗？'
      const param = {
        id: row.id
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post(url, param).then(() => {
            this.$message.success('操作成功')
            this.retrieve(this.currentNo)
          })
        })
        .catch(() => {})
    },
    // 重新申请交收
    reapply (row) {
      const type = row.deliveryDirection // 买卖方向
      if (type === 'B') { // 买方交收单
        this.$router.push({ path: `/framework/myTrading/myOrder/buyerDelivery/${row.orderId}/B?applyId=${row.id}` })
      } else { // 卖方交收单
        this.$router.push({ path: `/framework/myTrading/myOrder/sellerDelivery/${row.orderId}/S?applyId=${row.id}` })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .my-order-wrap{
    .right-wrap{
      /deep/ .el-input__inner{
        width: 200px;
      }
      /deep/ .el-button{
        min-width: 45px !important;
        height: 38px;
        background: #ff6b01;
        border-radius: 0;
        padding: 0 12px !important;
        i{
          color: white;
          font-size: 20px;
        }
      }
    }
    .auditRemark{
      cursor: default;
    }
    .tip_button{
      font-size: 12px;
      color: #e6a23c;
    }
  }
</style>
